import { handleActions } from 'redux-actions';
import * as profilesActions from '../actions/profiles';

let initState = {
  data: null,
  isLoading: false,
  drivers: null,
};

export const profiles = handleActions(
  {
    [profilesActions.getEmployees]: (state, action) => {
      return {
        ...state,
        isLoading: true,
      };
    },
    [profilesActions.getEmployeesSuccess]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        isLoading: false,
        data: payload,
      };
    },
    [profilesActions.getEmployeesError]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        isLoading: false,
        err: true,
        errMessages: payload.message,
      };
    },
    [profilesActions.getEmployeesSearchSuccess]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        dataSearch: payload,
      };
    },
    //  GET DRIVERS
    [profilesActions.getDrivers]: (state, action) => {
      return {
        ...state,
        isLoading: true,
      };
    },
    [profilesActions.getDriversSuccess]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        isLoading: false,
        drivers: payload,
      };
    },
    [profilesActions.getDriversFailure]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        isLoading: false,
        err: true,
        errMessages: payload.message,
      };
    },
  },
  initState
);
